import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {IApiDataResponse} from '../../../dto/API.dto';
import {IMediaPlaylistWithStation} from '../../../dto/MediaPlaylist.dto';
import {ISharedAssetItem} from '../../../dto/StationVisibility.dto';
import axiosInstance from '../../../axiosConfig';

export type IOndemandPlaylistResponse = IMediaPlaylistWithStation & {
  students_forms_count?: number;
  pending_students_forms_count?: number;
};

export interface IPlaylistListResponse
  extends IApiDataResponse<IOndemandPlaylistResponse[]> {
  shared_items?: ISharedAssetItem[];
}

export const onDemandLibraryListApiCall = (
  companyId: number,
  playlist: string,
) => `v1/company/${companyId}/${playlist}`;

const getPlaylist = (
  companyId: number,
  query: ICustomLibraryQueryParms,
  playlist: string,
) => {
  return axiosInstance
    .get(onDemandLibraryListApiCall(companyId, playlist), {params: query})
    .then((response: AxiosResponse<IPlaylistListResponse>) => {
      return response.data;
    });
};

export type ICustomLibraryQueryParms = {
  station_ids: number[];
  hidden: number;
  showAllMessage?: number;
};

export const useRqPlaylistList = (
  companyId: number = 0,
  query: ICustomLibraryQueryParms,
  playlist: string,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [onDemandLibraryListApiCall(companyId, playlist), query],
    queryFn: () => getPlaylist(companyId, query, playlist),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};
